import React, { useState } from 'react';
import { useBettingTimer } from './hooks/useBettingTimer';
import { useBettingState } from './hooks/useBettingState';
import BettingHeader from './components/BettingHeader';
import BettingCard from './components/BettingCard';
import './styles/card3d.css';

/**
 * 下注表格组件
 * 显示不同时间周期的下注选项，支持卡片翻转交互
 */
export default function PredictTable({ symbol, lastPrice = 2456.78, onClose }) {
  const { periods, getCountdownData, isLoading } = useBettingTimer();
  const { 
    flippedCard, 
    predictAmounts, 
    handleCardClick, 
    handleAmountChange, 
    handlePredict 
  } = useBettingState();

  // 包装下注处理函数
  const handlePredictWrapper = (periodMinutes, direction) => {
    handlePredict(periodMinutes, getCountdownData, symbol, direction, lastPrice);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="text-white/60">Loading...</div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-4xl mx-auto">
      {/* 头部组件 */}
      <BettingHeader 
        symbol={symbol}
        onClose={onClose}
      />

      {/* 横排3个卡片 */}
      <div className="grid grid-cols-3 gap-3">
        {periods.map((period) => {
          const data = getCountdownData(period.minutes);
          const isFlipped = flippedCard === period.minutes;
          
          return (
            <BettingCard
              key={period.minutes}
              period={period}
              data={data}
              lastPrice={lastPrice}
              amount={predictAmounts[period.minutes]}
              isFlipped={isFlipped}
              onCardClick={handleCardClick}
              onAmountChange={handleAmountChange}
              onPredict={handlePredictWrapper}
            />
          );
        })}
      </div>
    </div>
  );
}
